import { BaseView } from '@bingads-webui/base-view';
import $ from 'jquery';
import pgrid from 'projection-grid';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { download } from '@bingads-webui/download-service';
import * as putil from '@bingads-webui/primitive-utilities';
import { clientSidePaginationPlugin } from '@bingads-webui/projection-grid-client-pagination';
import { clientSideSortPlugin } from '@bingads-webui/projection-grid-client-sort';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import GridConfig from './grid-config';
import template from './template.pug';
import {
  dateFilterPlugin,
  fetchPreferenceConfig,
  instrumentation,
  toolbarTemplate,
} from '../../hotel-center-shared';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const edm = globalContext.requireDefault('campaignui/feature/hotel-center-edm/index');
const jsdata = globalContext.require('campaignui/feature/hotel-center-js-data/index');


export default class FeedStatus extends BaseView {
  initialize({ perfMarker = null }) {
    this.i18n = i18n;
    this.utilityPageScenario = instrumentation.utilityPage.create();
    if (perfMarker) {
      this.perfMarker = perfMarker.createChild('HotelCenterFeedStatus');
      this.perfMarker.willInit();
    }
  }

  get events() {
    return {
      'click .grid-table .downloadlink.reporturl': 'downloadFile',
    };
  }

  downloadFile(e) {
    const model = this.grid.gridView.itemOfElement(e.target);
    const feedId = putil.get(model, 'FeedId');

    return jsdata.TravelFeed
      .find(
        feedId,
        {
          entitySet: edm.currentCustomer.Feeds,
        }
      )
      .then((feed) => {
        download(feed.ReportUrl);
      });
  }

  render() {
    if (this.perfMarker) {
      this.perfMarker.willRender();
    }
    this.$el.html(template({
      title: i18n.getString('HotelCenter_Intelligence_FeedStatus_Description'),
    }));

    if ($('.intelligence-feed-status-toolbar-container .hotel-center-global-toolbar-containter').length === 0) {
      $('.intelligence-feed-status-toolbar-container').append(toolbarTemplate());
    }

    const config = new GridConfig({
      i18n,
      dateFilterContainer: this.$('.date-picker-container'),
    });
    const loadFeedStatusGridActivity = this.utilityPageScenario.loadFeedStatusGrid.create();

    fetchPreferenceConfig(config).then(() => {
      this.grid = pgrid
        .factory({ vnext: true })
        .use(paginationPlugin)
        .use(dateFilterPlugin)
        .use(placeholderPlugin)
        .use(uiBlockerPlugin)
        .use(clientSideSortPlugin)
        .use(clientSidePaginationPlugin)
        .create(config);

      this.grid.gridView.on('update:finished', () => {
        loadFeedStatusGridActivity.trace('Grid loading is completed');
      });

      this.grid.gridView.render(() => {
        super.render();
      });
      this.$('.grid-table').append(this.grid.gridView.$el);

      loadFeedStatusGridActivity.trace('Grid setup is completed');
      if (this.perfMarker) {
        this.perfMarker.done();
      }
    });

    return this;
  }

  remove(...args) {
    if (this.grid) {
      this.grid.gridView.remove();
      this.grid.pagination.remove();
    }
    super.remove(...args);
  }
}
